type AnalyticsValue = string | number | boolean | null | undefined;

type AnalyticsParams = Record<string, AnalyticsValue>;

type DataLayerEvent = AnalyticsParams & {
  event: string;
};

type WindowWithDataLayer = Window & {
  dataLayer?: DataLayerEvent[];
};

const getDataLayer = (): DataLayerEvent[] | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  const targetWindow = window as WindowWithDataLayer;
  if (!Array.isArray(targetWindow.dataLayer)) {
    targetWindow.dataLayer = [];
  }

  return targetWindow.dataLayer;
};

const compactParams = (params: AnalyticsParams): AnalyticsParams => {
  const result: AnalyticsParams = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined) {
      result[key] = value;
    }
  });

  return result;
};

export const trackGtmEvent = (event: string, params: AnalyticsParams = {}): void => {
  const dataLayer = getDataLayer();
  if (!dataLayer) {
    return;
  }

  dataLayer.push({
    event,
    ...compactParams(params),
  });
};

